import DocSignerService from '@/services/bytepro/docSigner.service';

export const docSigner = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    get({ commit }, fileDataId){
      return DocSignerService.get(fileDataId).then(
        resp => {
          commit('dummy', "get - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "get - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    }
  }
};